//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

const MS_PER_SECOND = 1000;

export const getMsToSeconds = (ms: number = 0) => ms / MS_PER_SECOND;

export const getSecondsToMs = (seconds: number = 0) => seconds * MS_PER_SECOND;
